export function detectColorMode(): 'light' | 'dark' {
    if (window?.matchMedia('(prefers-color-scheme: dark)')?.matches) {
        return 'dark';
    }

    return 'light';
}